import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const EVENT_MENU: PermissionTableRowType = {
  name: '기획전',
  key: 'EVENT_MANAGE',
  subRows: [
    {
      name: '기획전 관리',
      key: PERMISSION_SUBJECTS.EVENT,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.CREATE,
        PERMISSION_ACTIONS.UPDATE,
      ],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.EVENT,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '기획전 등록',
          key: PERMISSION_SUBJECTS.EVENT,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
        {
          name: '기획전 편집',
          key: PERMISSION_SUBJECTS.EVENT,
          permissions: [PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.UPDATE],
        },
      ],
    },
  ],
};
